import Vue from 'vue'

// 批量引入
import PublicComponents from '~/public'
Vue.use(PublicComponents)

// 单个指定引入
// import { ConBox } from '~/public/index.js'
// Vue.use(ConBox)


// WEBPACK FOOTER //
// ./plugins/Components.js